import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslocoModule } from '@jsverse/transloco';
import { NgxMaskPipe } from 'ngx-mask';
import { BazisCoreSharedModule } from '@bazis/shared/core-shared.module';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        RouterModule,
        ReactiveFormsModule,
        TranslocoModule,
        BazisCoreSharedModule,
        NgxMaskPipe,
    ],
    exports: [BazisCoreSharedModule, NgxMaskPipe],
})
export class SharedModule {}
